// source: witbooking/backoffice/blacklist/v1/blacklist.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.displayName = 'proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.displayName = 'proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.displayName = 'proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.displayName = 'proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    propagateToChildren: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest;
  return proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addEmails(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPropagateToChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getPropagateToChildren();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated string emails = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.prototype.getEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} returns this
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.prototype.setEmailsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} returns this
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.prototype.addEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} returns this
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.prototype.clearEmailsList = function() {
  return this.setEmailsList([]);
};


/**
 * optional bool propagate_to_children = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.prototype.getPropagateToChildren = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest} returns this
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistRequest.prototype.setPropagateToChildren = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse;
  return proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.blacklist.v1.UpsertEngineBlacklistResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest;
  return proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    managedByChain: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse;
  return proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addEmails(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setManagedByChain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getManagedByChain();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated string emails = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.prototype.getEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse} returns this
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.prototype.setEmailsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse} returns this
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.prototype.addEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse} returns this
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.prototype.clearEmailsList = function() {
  return this.setEmailsList([]);
};


/**
 * optional bool managed_by_chain = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.prototype.getManagedByChain = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse} returns this
 */
proto.witbooking.backoffice.blacklist.v1.GetBlacklistedUsersResponse.prototype.setManagedByChain = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.blacklist.v1);
